module.exports = __webpack_public_path__ + "img/DE01014.e64b34c6.png";